<template>
  <div>
    <HeaderSession v-if="user" :dateExpire="dateExpire"></HeaderSession>
    <HeaderCustom v-if="$route.name !== 'Landing'" />
    <main>
      <slot></slot>
    </main>
    <ModalProtocols v-if="false" v-model="modalProtocols" />
    <CookieModal
      v-show="!existCookies && $route.name !== 'DetailMobile'"
      :showCookies="!existCookies && $route.name !== 'DetailMobile'"
    />
    <FooterCustom v-if="isMobile && !isFPF" />
  </div>
</template>

<script>
import { getCookie, removeCookie, cookieDetailList } from '../utils/cookies';
import api from '../api';

const ModalProtocols = () => Promise.resolve(import('../components/ModalProtocols.vue'));
const FooterCustom = () => Promise.resolve(import('../components/layouts/FooterCustom.vue'));
const CookieModal = () => Promise.resolve(import('../components/cookies/CookieModal.vue'));
const HeaderCustom = () => Promise.resolve(import('../components/layouts/HeaderCustom.vue'));
const HeaderSession = () => Promise.resolve(import('../components/HeaderSession.vue'));

export default {
  components: {
    CookieModal,
    ModalProtocols,
    FooterCustom,
    HeaderCustom,
    HeaderSession,
  },
  data() {
    return {
      toggleNav: true,
      modalProtocols: false,
      slug: null,
      existCookies: true
    };
  },
  computed: {
    showButtons() {
      const { name } = this.$route;
      return name === 'Menu';
    },
    isMobile() {
      const { name } = this.$route;
      return name !== 'DetailMobile' && name !== 'Landing';
    },
    isFPF() {
      return this.hostname === 'preprodfpf.joinnus' || this.hostname === 'fpf.joinnus.com' || this.nameRouter === 'Fpf';
    },
    nameRouter() {
      return this.$route.name;
    },
    hostname() {
      return window.location.hostname;
    },
    user() {
      return this.$store.state.auth.user;
    },
    auth() {
      return this.$store.state.auth;
    },
    dateExpire() {
      return this.$store.state.auth.expire;
    },
  },
  async mounted() {
    if (!window.location.pathname.includes('/mobile/detail')) {
      await this.addHotJar();
      const existCookie = getCookie('consentCookies');
      const existCookieAux = getCookie('sendCookies');
      if (existCookie && this.user) {
        const cookieList = cookieDetailList.map((c) => ({
          ...c,
          isChecked: c.title === 'Necesario' || true,
        }));
        const payload = cookieList.map((fc) => ({
          type: fc.key,
          state: fc.isChecked ? 1 : 0,
          details: [],
        }));
        await api.setCookies({ cookies: payload }, this.auth.token);
      }
      this.existCookies =  existCookie && !existCookieAux;
    }
  },
  methods: {
    async validateCookie() {
      const { auth } = this.$store.state;
      const existCookie = getCookie('consentCookies');
      const existCookieAux = getCookie('sendCookies');
      if (auth && auth.user && existCookie && existCookieAux) {
        const cookieList = JSON.parse(existCookie);
        const payload = cookieList.map((fc) => ({
          type: fc.key,
          state: fc.isChecked ? 1 : 0,
          details: [],
        }));
        await api.setCookies({ cookies: payload }, auth.token);
        removeCookie('sendCookies');
      }
    },
  },
  created() {
    const { slug } = this.$route.params;
    this.slug = slug;
    const pm = window.sessionStorage.getItem('protocols');
    if (pm) {
      this.modalProtocols = false;
    } else {
      setTimeout(() => {
        this.modalProtocols = true;
      }, 8000);
    }
  },
};
</script>
